$(function () {
  $('.logo-bar-section .logo-bar.logo-mobile-slider').slick({
    slidesToShow: 6,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    cssEase: 'linear',
    infinite: true,
    focusOnSelect: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 5
      }
    }, {
      breakpoint: 580,
      settings: {
        arrows: false,
        slidesToShow: 3
      }
    }, {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    }]
  });
});